import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

import {FullLayoutComponent} from './layouts/full-layout/full-layout.component';
import {CommonLayoutComponent} from './layouts/common-layout/common-layout.component';
import {COMMON_LAYOUT_ROUTES} from '@app/layouts/common-layout/common-layout.routes';
import {FULL_LAYOUT_ROUTES} from '@app/layouts/full-layout/full-layout.routes';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: CommonLayoutComponent,
    children: COMMON_LAYOUT_ROUTES
  },
  {
    path: '',
    component: FullLayoutComponent,
    children: FULL_LAYOUT_ROUTES
  },
  {path: '**', redirectTo: '/page/error-404', pathMatch: 'full'}

];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule {
}
